import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { observer } from 'mobx-react-lite';
import AuctionDto from 'models/backend/AuctionDto';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StoreContext } from 'stores';
import FutureAuctionsWidget from './futureAuctionsWidget';

const useStyles = makeStyles(theme => ({
  widget: {
    marginBottom: theme.spacing(2),
  },
}));

interface SidebarProps {}

const Sidebar: React.FunctionComponent<SidebarProps> = observer(() => {
  const styles = useStyles();
  const { auctionStore } = React.useContext(StoreContext);
  const { t } = useTranslation();

  const futureAuctions = auctionStore.futureAuctions();
  if (!futureAuctions) {
    return null;
  }

  return (
    <div>
      <Typography gutterBottom variant="h6">
        {t('frontpage_next_auctions')}
      </Typography>
      {futureAuctions.length > 0 &&
        futureAuctions.map((x: AuctionDto) => (
          <div key={x.id} className={styles.widget}>
            <FutureAuctionsWidget auction={x} />
          </div>
        ))}
    </div>
  );
});

export default Sidebar;
